import { render, staticRenderFns } from "./BranchEmails.vue?vue&type=template&id=91b32bf2&"
import script from "./BranchEmails.vue?vue&type=script&lang=js&"
export * from "./BranchEmails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports